
import AwaitModalComponent from '@/components/Shared/Modals/AwaitModal/AwaitModalComponent';
export default AwaitModalComponent;
